import css from "./NotificationToast.module.css";
import { selectToasts } from "../../redux/notifications/selectors.js";
import ToastItem from "./ToastItem.jsx";
import { useSelector } from "react-redux";
import { useCan } from "../../utils/permissions.js";

export default function NotificationToast() {
  const toasts = useSelector(selectToasts);
  const can = useCan();

  if (toasts.length === 0) return null;

  const accessibleList = toasts.filter(
    notification =>
      can("notifications", "read") ||
      notification.type === "error" ||
      notification.type === "warning"
  );

  return (
    <div className={css.container}>
      {accessibleList.map(toast => (
        <ToastItem key={toast.id} toast={toast} />
      ))}
    </div>
  );
}
